<app-hero-courses></app-hero-courses>
<!-- <div class="first container grid">
  <div class="row my-4">
    <div class="col-xl d-flex justify-content-center align-items-center my-3">
      <img src="../../../../assets/img/educatori.png" alt="" />
    </div>
    <div class="col-xl d-flex justify-content-center align-items-center mt-5">
      <img src="../../../../assets/img/12moduli.png" alt="" />
    </div>
  </div>
</div> -->

<div class="second container grid">
  <h3 class="w-700 blue-50 text-center">
    User Experience (UX) <br />
    User Interface (UI)
  </h3>
  <p class="w-500 neutral-100 px-2 px-xl-5">
    Da dove si parte per trovare la soluzione a un problema degli utenti? Cos’è
    la user experience e come si può migliorare? Attraverso il corso i ragazzi
    impareranno come le persone si relazionano con un prodotto, un servizio o un
    sistema, cos’è il metodo del design, come costruire interfacce grafiche
    efficaci.
  </p>
</div>

<div class="third container grid">
  <div class="row">
    <div class="col text-center">
      <img
        src="../../../../assets/img/phone-ux.png"
        alt="Telefono"
       
        class="phone-ux"
      />
    </div>
  </div>
</div>

<div class="fourth container grid">
  <h3 class="w-700 blue-50 text-center">UX. L'interazione.</h3>
  <p class="w-500 neutral-100 px-2 px-xl-5">
    Comprendere quei processi volti ad aumentare la soddisfazione degli utenti,
    migliorando la facilità di navigazione e rendendo più intuitiva la
    consultazione delle pagine web. La User Experience consente di realizzare
    siti web all’insegna della <span class="underline-p">semplicità</span>,
    della <span class="underline-p">praticità</span>, della
    <span class="underline-a">coerenza</span> alle
    <span class="underline-a">aspettative dell’utilizzatore</span>.
  </p>
</div>

<div class="fifth container grid">
  <div class="row">
    <div class="col text-center">
      <img
        src="../../../../assets/img/draw.png"
        alt="Progettazione"
       
        class="draw"
      />
    </div>
  </div>
</div>

<div class="sixth container grid">
  <h3 class="w-700 blue-50 text-center">UI. L'interfaccia visiva.</h3>
  <p class="w-500 neutral-100 px-2 px-xl-5">
    <span class="underline-p">Guida l’utente attraverso l’interfaccia</span>,
    indicandogli con chiarezza e precisione dove può trovare ciò che cerca in
    ottica coerente e prevedibile. Utilizza font e colori piacevoli ed efficaci
    per lo scopo del sito e colloca gli elementi nelle posizioni più facilmente
    individuabili dagli utenti. In questo modo il
    <span class="underline-a"
      >reperimento delle informazioni risulta rapido ed intuitivo</span
    >.
  </p>
</div>

<div class="seventh container grid">
  <div class="row">
    <div class="col text-center">
      <img
        src="../../../../assets/img/colors.png"
        alt="Colori"
       
        class="colors"
      />
    </div>
  </div>
</div>

<app-modules [data]="modulesText"></app-modules>
<app-iscriviti></app-iscriviti>
